import axios from '@/http.js';
const prefix = 'api/admin/category'

const httpRequest = (fn) => {
  return new Promise((resolve, reject) => {
    fn.then(d => {
      const { data } = d
      if (data.code === 200) {
        resolve(data.result || {})
      } else {
        reject(data)
      }
    })
  })
}

// 模板类目列表
export const getCategoryList = (id) => {
  return httpRequest(axios.get(`${prefix}/list`, { params: { projectId: id } }))
}
// 添加模板类目
export const addCategory = (data) => {
  return httpRequest(axios.post(`${prefix}/add`, data))
}
// 编辑模板类目
export const editCategory = (data) => {
  return httpRequest(axios.put(`${prefix}/edit`, data))
}
// 删除模板类目
export const delCategory = (id) => {
  return httpRequest(axios.delete(`${prefix}/delete/${id}`))
}
// 下移类目
export const moveDown = (id) => {
  return httpRequest(axios.put(`${prefix}/moveDown/${id}`))
}
// 上移类目
export const moveUp = (id) => {
  return httpRequest(axios.put(`${prefix}/moveUp/${id}`))
}